// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1156":"586a00a6564658e5","2498":"ff3740f1a4137709","3465":"07d219305a5504d8","3775":"245d736891f74696","6741":"8f557ae51548b870","8478":"901eb80c84e01071","8663":"b72974f5eb26f3e1"}[chunkId] + ".js";
};